// Source: app/scripts/controllers/web-portal-welcome-page.js
/**
 * Created by ristes on 20.4.15.
 */

Auction.controller('WebPortalWelcomePageController', [
  '$scope',
  '$routeParams',
  '$rootScope',
  '$location',
  '$cookieStore',
  '$filter',
  'UserService',
  'toaster',
  'crudService',
  'settings',
  'Page',
  function ($scope, $routeParams, $rootScope, $location,
            $cookieStore, $filter, UserService, toaster,
            crudService, settings, Page) {

    $scope.assetsVersion = settings.version;

    $scope.rememberMe = false;
    $scope.welcomeAboutContent = '';

    function welcomePageName() {
      var lang = ($rootScope.LANG || 'EN').toLowerCase();
      if (lang === 'sq' || lang === 'sr') {
        return 'eauction_welcome_' + lang;
      }
      return 'eauction_welcome_en';
    }

    function loadWelcomeAbout() {
      Page.findPageContent({
        name: welcomePageName()
      }, function (data) {
        $scope.welcomeAboutContent = data && data.content ? data.content : '';
      }, function () {
        $scope.welcomeAboutContent = '';
      });
    }

    loadWelcomeAbout();
    $rootScope.$watch('LANG', function (n, o) {
      if (n && n !== o) {
        loadWelcomeAbout();
      }
    });

    var confirmService = crudService('registered_users', {
      'confirm': {
        method: 'POST',
        url: '/data/rest/registered_users/confirm'
      }
    });

    if ($routeParams.code) {
      confirmService.confirm({
        code: $routeParams.code
      }, function () {
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')('eauction.user_confirmed'));
        $location.search('code', null);
      });
    }

    if ($routeParams.error) {
      toaster.pop('error', $filter('translate')('generic.error'),
        $filter('translate')($routeParams.error));
    }
    if ($routeParams.info) {
      toaster.pop('success', $filter('translate')('generic.success'),
        $filter('translate')($routeParams.info));
    }
    $scope.renewPassword = function () {

      UserService.passwordRenew({
        username: $scope.username
      }, function () {
        $location.path("/login");
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')('generic.password_sent_via_email'));
      });

    };

    $scope.remindUsername = function () {

      UserService.remindUsername({
        email: $scope.email
      }, function () {
        $location.path("/login");
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')('generic.username_sent_via_email'));
      });

    };


  }
]);
